// extracted by mini-css-extract-plugin
export default {"Loader":"styles_Loader__WJBi6","relative":"styles_relative__Rq50T"};